// see http://vuejs-templates.github.io/webpack for documentation.
module.exports = {
  app: require('../config/app')
}
